import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<input/>`);

export default function Checkbox($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		checked = $.prop($$props, 'checked', 15, false),
		restProps = $.rest_props($$props, ['$$slots', '$$events', '$$legacy', 'ref', 'checked', 'class']);

	var input = root();

	$.attribute_effect(
		input,
		($0) => ({ type: 'checkbox', class: $0, ...restProps }),
		[
			() => cn("h-4 w-4 shrink-0 rounded border border-input bg-background shadow-xs transition-colors", "checked:bg-primary checked:border-primary checked:accent-primary", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "disabled:cursor-not-allowed disabled:opacity-50", $$props.class)
		],
		void 0,
		void 0,
		void 0,
		true
	);

	$.bind_this(input, ($$value) => ref($$value), () => ref());
	$.bind_checked(input, checked);
	$.append($$anchor, input);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2hlY2tib3guc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG5cdGltcG9ydCB0eXBlIHsgSFRNTElucHV0QXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblx0aW1wb3J0IHsgY24sIHR5cGUgV2l0aEVsZW1lbnRSZWYgfSBmcm9tIFwiJGxpYi91dGlscy5qc1wiO1xuXG5cdHR5cGUgUHJvcHMgPSBXaXRoRWxlbWVudFJlZjxPbWl0PEhUTUxJbnB1dEF0dHJpYnV0ZXMsIFwidHlwZVwiPj4gJiB7XG5cdFx0Y2hlY2tlZD86IGJvb2xlYW47XG5cdH07XG5cblx0bGV0IHtcblx0XHRyZWYgPSAkYmluZGFibGUobnVsbCksXG5cdFx0Y2hlY2tlZCA9ICRiaW5kYWJsZShmYWxzZSksXG5cdFx0Y2xhc3M6IGNsYXNzTmFtZSxcblx0XHQuLi5yZXN0UHJvcHNcblx0fTogUHJvcHMgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuXG48aW5wdXRcblx0YmluZDp0aGlzPXtyZWZ9XG5cdHR5cGU9XCJjaGVja2JveFwiXG5cdGJpbmQ6Y2hlY2tlZFxuXHRjbGFzcz17Y24oXG5cdFx0XCJoLTQgdy00IHNocmluay0wIHJvdW5kZWQgYm9yZGVyIGJvcmRlci1pbnB1dCBiZy1iYWNrZ3JvdW5kIHNoYWRvdy14cyB0cmFuc2l0aW9uLWNvbG9yc1wiLFxuXHRcdFwiY2hlY2tlZDpiZy1wcmltYXJ5IGNoZWNrZWQ6Ym9yZGVyLXByaW1hcnkgY2hlY2tlZDphY2NlbnQtcHJpbWFyeVwiLFxuXHRcdFwiZm9jdXMtdmlzaWJsZTpvdXRsaW5lLW5vbmUgZm9jdXMtdmlzaWJsZTpyaW5nLTIgZm9jdXMtdmlzaWJsZTpyaW5nLXJpbmcgZm9jdXMtdmlzaWJsZTpyaW5nLW9mZnNldC0yXCIsXG5cdFx0XCJkaXNhYmxlZDpjdXJzb3Itbm90LWFsbG93ZWQgZGlzYWJsZWQ6b3BhY2l0eS01MFwiLFxuXHRcdGNsYXNzTmFtZVxuXHQpfVxuXHR7Li4ucmVzdFByb3BzfVxuLz4iXSwibWFwcGluZ3MiOiI7O1NBRVUsRUFBRSxRQUE2QixlQUFlOzs7O29EQUZ4RCxDQUFDOzs7S0FTQyxHQUFHLDhCQUFhLElBQUk7RUFDcEIsT0FBTyxrQ0FBYSxLQUFLO0VBRXRCLFNBQVM7Ozs7Ozs2Q0FlVCxTQUFTOztTQVBOLEVBQUUsQ0FDUix3RkFBd0YsRUFDeEYsa0VBQWtFLEVBQ2xFLHFHQUFxRyxFQUNyRyxpREFBaUQ7Ozs7Ozs7O2lDQVB2QyxHQUFHLGlCQUFILEdBQUc7Ozs7QUFIaEIsQ0FBQyJ9